import { render, staticRenderFns } from "./RoleUserInfo.vue?vue&type=template&id=19ef4c1a&scoped=true&"
import script from "./RoleUserInfo.vue?vue&type=script&lang=js&"
export * from "./RoleUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoleUserInfo.vue?vue&type=style&index=0&id=19ef4c1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef4c1a",
  null
  
)

export default component.exports